(function () {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  function formatMoney(cents) {
    const fmt = (window.theme && window.theme.moneyFormat) || "R {{amount}}";
    const v = (cents / 100);
    const withDelim = (n, d, t, s) => n.toFixed(d).replace(/\B(?=(\d{3})+(?!\d))/g, t).replace(/\.(\d+)$/, s + "$1");
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => {
      switch (k) {
        case "amount_no_decimals": return withDelim(v, 0, ",", ".");
        case "amount_with_comma_separator": return withDelim(v, 2, ".", ",");
        case "amount_no_decimals_with_comma_separator": return withDelim(v, 0, ".", ",");
        case "amount_with_space_separator": return withDelim(v, 2, " ", ",");
        default: return withDelim(v, 2, ",", ".");
      }
    });
  }
  const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));

  function toast(msg) {
    const t = $("#Toast"); if (!t) return;
    t.textContent = msg; t.classList.add("show");
    clearTimeout(t._h); t._h = setTimeout(() => t.classList.remove("show"), 2600);
  }

  /* Drawers */
  function openDrawer(id) { const d = document.getElementById(id); if (d) { d.classList.add("open"); document.body.style.overflow = "hidden"; } }
  function closeDrawer(d) { d.classList.remove("open"); document.body.style.overflow = ""; }
  document.addEventListener("click", (e) => {
    const opener = e.target.closest("[data-open-drawer]");
    if (opener) { e.preventDefault(); if (opener.dataset.openDrawer === "CartDrawer") refreshCart(); openDrawer(opener.dataset.openDrawer); }
    const closer = e.target.closest("[data-close-drawer]");
    if (closer) closeDrawer(closer.closest(".drawer"));
  });
  document.addEventListener("keydown", (e) => { if (e.key === "Escape") $$(".drawer.open").forEach(closeDrawer); });

  /* Search toggle */
  const st = $("[data-search-toggle]");
  if (st) st.addEventListener("click", () => { const b = $("#SearchBar"); b.classList.toggle("open"); if (b.classList.contains("open")) $("input", b).focus(); });

  /* Cart */
  async function getCart() { const r = await fetch(window.theme.routes.cart + ".js", { headers: { Accept: "application/json" } }); return r.json(); }

  function renderCart(cart) {
    $$("[data-cart-count]").forEach((el) => { el.textContent = cart.item_count || ""; el.dataset.count = cart.item_count; });
    const body = $("#CartDrawerBody"), foot = $("#CartDrawerFoot"), sub = $("#CartDrawerCount");
    if (!body) return;
    sub.textContent = cart.item_count === 0 ? "Your bag is empty" : `${cart.item_count} item${cart.item_count !== 1 ? "s" : ""}`;
    if (!cart.items.length) {
      body.innerHTML = `<div class="empty-state"><p class="eyebrow" style="font-size:1.15rem">Find your crown</p><a href="/collections/all" class="btn" style="margin-top:1.5rem">Shop now</a></div>`;
      foot.hidden = true; return;
    }
    foot.hidden = false;
    body.innerHTML = cart.items.map((it, i) => `
      <div class="cart-line">
        <a href="${it.url}" class="cart-line__img">${it.image ? `<img src="${it.image}&width=200" alt="${esc(it.product_title)}" loading="lazy">` : ""}</a>
        <div class="cart-line__info">
          <a href="${it.url}" class="cart-line__title">${esc(it.product_title)}</a>
          ${it.variant_title ? `<p class="cart-line__variant">${esc(it.variant_title)}</p>` : ""}
          <p style="font-size:.85rem;margin-top:.25rem">${formatMoney(it.final_line_price)}</p>
          <div class="cart-row" style="margin-top:.5rem">
            <div class="qty"><button type="button" data-line="${i + 1}" data-qty="${it.quantity - 1}" aria-label="Decrease">−</button><span>${it.quantity}</span><button type="button" data-line="${i + 1}" data-qty="${it.quantity + 1}" aria-label="Increase">+</button></div>
            <button type="button" class="remove" data-line="${i + 1}" data-qty="0">Remove</button>
          </div>
        </div>
      </div>`).join("");
    $("#CartDrawerTotal").textContent = formatMoney(cart.total_price);
  }

  async function refreshCart() { try { renderCart(await getCart()); } catch (e) { console.error(e); } }

  async function changeLine(line, quantity) {
    const r = await fetch(window.theme.routes.cartChange + ".js", {
      method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ line, quantity }),
    });
    const cart = await r.json();
    if (!r.ok) { toast(cart.description || "Couldn't update your bag"); return refreshCart(); }
    renderCart(cart);
    if (document.body.classList.contains("template-cart")) location.reload();
  }

  document.addEventListener("click", (e) => {
    const b = e.target.closest("#CartDrawerBody [data-line]");
    if (b) { b.disabled = true; changeLine(Number(b.dataset.line), Number(b.dataset.qty)); }
  });

  async function addToCart(items, btn) {
    const label = btn ? btn.innerHTML : "";
    if (btn) { btn.disabled = true; btn.innerHTML = "Adding…"; }
    try {
      const r = await fetch(window.theme.routes.cartAdd + ".js", {
        method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items }),
      });
      const data = await r.json();
      if (!r.ok) { toast(data.description || data.message || "Couldn't add to bag"); return; }
      toast(`Added to your bag — ${data.items[0].product_title}`);
      await refreshCart();
      openDrawer("CartDrawer");
    } catch (e) { toast("Something went wrong. Please try again."); }
    finally { if (btn) { btn.disabled = false; btn.innerHTML = label; } }
  }

  /* Quick add */
  document.addEventListener("click", (e) => {
    const q = e.target.closest("[data-quick-add]");
    if (q) { e.preventDefault(); addToCart([{ id: Number(q.dataset.quickAdd), quantity: 1 }], q); }
  });

  /* Product form */
  $$("[data-product-form]").forEach((form) => {
    const json = $("[data-product-json]", form.closest("[data-product]"));
    const product = json ? JSON.parse(json.textContent) : null;
    const idInput = $("input[name=id]", form);
    const btn = $("[data-add-button]", form);
    const root = form.closest("[data-product]");

    function update() {
      if (!product) return;
      const picked = $$("[data-option]", root).filter((i) => i.checked).map((i) => i.value);
      const variant = product.variants.find((v) => v.options.every((o, i) => o === picked[i]));
      $$("[data-option-label]", root).forEach((el, i) => (el.textContent = picked[i] || ""));
      if (!variant) { btn.disabled = true; btn.textContent = "Unavailable"; return; }
      idInput.value = variant.id;
      btn.disabled = !variant.available;
      btn.textContent = variant.available ? "Add to bag" : "Sold out";
      const price = $("[data-price]", root), cmp = $("[data-compare]", root);
      if (price) price.textContent = formatMoney(variant.price);
      if (cmp) { const sale = variant.compare_at_price && variant.compare_at_price > variant.price; cmp.textContent = sale ? formatMoney(variant.compare_at_price) : ""; cmp.hidden = !sale; }
      if (variant.featured_media) {
        const t = $(`[data-media-id="${variant.featured_media.id}"]`, root);
        if (t) t.click();
      }
      const url = new URL(location.href); url.searchParams.set("variant", variant.id); history.replaceState(null, "", url);
    }
    $$("[data-option]", root).forEach((i) => i.addEventListener("change", update));

    const qtyInput = $("input[name=quantity]", form);
    $$("[data-qty-step]", form).forEach((b) => b.addEventListener("click", () => {
      qtyInput.value = Math.max(1, Number(qtyInput.value || 1) + Number(b.dataset.qtyStep));
    }));

    form.addEventListener("submit", (e) => {
      e.preventDefault();
      addToCart([{ id: Number(idInput.value), quantity: Math.max(1, Number(qtyInput.value || 1)) }], btn);
    });
  });

  /* Gallery */
  document.addEventListener("click", (e) => {
    const t = e.target.closest("[data-thumb]");
    if (!t) return;
    const root = t.closest("[data-product]");
    const main = $("[data-main-image]", root);
    main.src = t.dataset.thumb; main.srcset = "";
    $$("[data-thumb]", root).forEach((x) => x.classList.toggle("active", x === t));
  });

  /* Sort */
  $$("[data-sort]").forEach((s) => s.addEventListener("change", () => {
    const url = new URL(location.href); url.searchParams.set("sort_by", s.value); location.href = url.toString();
  }));

  /* Cart page qty */
  $$("[data-cart-page-line]").forEach((b) => b.addEventListener("click", () => changeLine(Number(b.dataset.cartPageLine), Number(b.dataset.qty))));

  refreshCart();
})();
